<template>
<body id="page-top" class="body-bg">
        <!-- Navigation-->
        <nav class="navbar navbar-expand-lg bg-secondary text-uppercase fixed-top" id="mainNav">
            <div class="container">
                <img class="navbar-brand" href="#page-top" src="../assets/philcare-logo.png"/>
                    <i class="fas fa-bars"></i>
            </div>
        </nav>
        <section class="page-section portfolio certificate-login-section" id="portfolio">
            <div class="container">
              <form autocomplete="off" @submit.prevent="handleSubmit">
                <div class="login-form" >
                  <p class="h4">WHAT IS YOUR CERTIFICATE NUMBER?</p>
                  <div class="col-sm-10" id="divOuter">
                    <div id="divInner">
                      <!--<div class="password-input">
                        <input v-model="password[0]" type="password" maxlength="1" @input="moveToNext(0, $event)" @keydown="handleBackspace($event, 0)" />
                        <input v-model="password[1]" type="password" maxlength="1" @input="moveToNext(1, $event)" @keydown="handleBackspace($event, 1)" />
                        <input v-model="password[2]" type="password" maxlength="1" @input="moveToNext(2, $event)" @keydown="handleBackspace($event, 2)" />
                        <input v-model="password[3]" type="password" maxlength="1" @input="moveToNext(3, $event)" @keydown="handleBackspace($event, 3)" />
                        <input v-model="password[4]" type="password" maxlength="1" @input="moveToNext(4, $event)" @keydown="handleBackspace($event, 4)" />
                        <input v-model="password[5]" type="password" maxlength="1" @input="moveToNext(5, $event)" @keydown="handleBackspace($event, 5)" />
                        <input v-model="password[6]" type="password" maxlength="1" @input="moveToNext(6, $event)" @keydown="handleBackspace($event, 6)" />
                        </div>
                      <p id="password-error">{{ passwordError }}</p>-->

                      <input v-model="certNo" type="password" class="form-control" @focus="show" data-layout="normal" id="partitioned" maxlength="7" />
                      </div>
                    </div>
                </div>
                <div class="col-md-12">
                  <router-link to="/options-login"><a style="float:left" type="button" class="btn btn-primary btn-lg">CANCEL</a></router-link>
                  <a type="button" class="btn btn-primary btn-lg"><router-link to="/options-login">PREVIOUS</router-link></a>
                  <button class="btn btn-primary btn-lg">NEXT</button>
                  <!--<a type="button" class="btn btn-primary btn-lg"><router-link to="/member-page">NEXT</router-link></a>-->
                </div>
                </form>
            </div>
        
                <div>
                  <b-modal content-class="customer-adv-modal" centered title="" ref="my-modal" id="modal-center">
                    <p class="my-4">{{returnMessage}}</p>
                  </b-modal>
                  <b-modal content-class="customer-adv-modal" centered title="" ref="my-modal2" id="modal-center" hide-header-close="true" no-close-on-esc="true" no-close-on-backdrop="true" >
                    <p class="my-4">{{returnMessage}}</p>
                    <button class="btn btn-primary btn-lg" @click="hideModal2">EXIT</button>
                  </b-modal>
              </div>
          </section>
         <div class='spinner load' v-if='loading'><img src="../assets/phil-care-loading-logo.gif"/></div>
        
</body>
</template>

<script>
import axios from 'axios';
export default {
  name: 'PhilLogin',
  data() {
    return {
      password: ['', '', '', '', '', '', ''],
      passwordError: '',
      certNo: '',
      returnMessage: '',
      success: false,
            error: false,
            loading: false,
            visible: false,
        layout: "normal",
        input: null,
        options: {
        useKbEvents: false,
        preventClickEvent: false
      },
      memberFPS : true
      
    }
  },
  methods: {
    moveToNext(index, event) {
      const maxLength = parseInt(event.target.getAttribute('maxlength'));
      const currentLength = event.target.value.length;
      
      if (currentLength >= maxLength) {
        const nextInput = event.target.nextElementSibling;
        if (nextInput) {
          nextInput.focus();
        }
      }
    },

    handleBackspace(event, index) {
      if (event.key === 'Backspace' && this.password[index] === '') {
        // Prevent the default backspace behavior
        event.preventDefault();
        // If the input is empty and backspace is pressed, move focus to the previous input box
        const previousInput = event.target.previousElementSibling;
        if (previousInput) {
          previousInput.focus();
        }
      }
    },
    async handleSubmit() {
        this.loading = true
        this.returnMessage = ""
        //this.certNo = this.password.join('');
        //console.log(this.certNo)
        const response = await axios.post('/api/?action=member-login', {
           CertNo: this.certNo
        }, 
        );
       // this.showModal()
        console.log(response);
        if (response.data.SuccessFlag == 'True'){
            //localStorage.setItem('TokenID', response.data.TokenID)
            this.memberFPS = response.data.memberFPS
            //localStorage.setItem('CertNo', this.certNo)
            localStorage.setItem('CertNo', response.data.CertNo)
            localStorage.setItem('AgmtNo', this.agmtNo)
            localStorage.setItem('isMayaAccount', response.data.IsMAYAAcct)
            
            const isYes = v => String(v || '').trim().toUpperCase() === 'Y';

            localStorage.setItem('allowLOAConsult', isYes(response.data.AllowLOAConsultation) ? '1' : '0')
            localStorage.setItem('allowLOALab', isYes(response.data.AllowLOAProcedure) ? '1' : '0')
                        
            this.returnMessage = "You have successfully logged in to your account."
            //if ( this.memberFPS == 'True') {
            //  this.returnMessage = "You have successfully logged in to your account."
            //} else {
            //   this.returnMessage = response.data.MessageReturn
           // }
            this.showModal()
            setTimeout(() => this.$router.push('/member-page'), 2000);
            this.loading = false
        } else {
            this.returnMessage = response.data.MessageReturn
           /* this.returnMessage = `"Healthy day. 
We apologize but you do not have access in this digital platform. For urgent concern, please call our 24/7 hotline at 02-84621800. 
For non urgent case or concern, please email us at callcenter@philcare.com.ph. 
Thank you and stay safe."` */
            this.showModal2()
            console.log(this.returnMessage);
            this.loading = false
        }
    },
          showModal() {
            this.$refs['my-modal'].show()
          },
          showModal2() {
            this.$refs['my-modal2'].show()
          },
          hideModal() {
            this.$refs['my-modal'].hide()
          },
          hideModal2() {
            this.$refs['my-modal2'].hide()
            this.$router.push('/login')
          },
          accept() {
          this.hide();
        },
 
        show(e) {
          this.input = e.target;
          this.layout = e.target.dataset.layout;
 
          if (!this.visible)
            this.visible = true
        },
 
        hide() {
          this.visible = false;
          console.log(document.querySelector(":focus"));
        },
        restrictChars() {
          console.log("enter");
        }

  }
}


</script>
<style>
  .password-input {
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-bottom: 20px;
  }
  .password-input input {
    width: 90px;
    height: 70px;
    text-align: center;
    font-size: 2em;
    border: 1px solid #ccc;
    border-radius: 5px;
  }
  #password-error {
    color: red;
  }
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
